var UtilRandom = /** @class */ (function () {
    function UtilRandom() {
        this.getRandomNumberInRange = function (low, high) {
            return Math.floor(Math.random() * (high - low)) + low;
        };
    }
    return UtilRandom;
}());
export var utilRandom = new UtilRandom();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilRandom.ts
// module id = 952
// module chunks = 3